// ** React Imports
import { useState, useEffect, useRef, useCallback } from 'react'
import { useExtremeUpgradeRefresh } from 'src/hooks/useExtremeUpgradeRefresh'

import { useTranslation } from 'src/utils/i18n'

// ** Next Imports
import Link from 'next/link'
import { styled } from '@mui/material/styles'
import Head from 'next/head'

// request
import { getAllDashboard } from '/src/@api/dashboard'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { useDispatch, useSelector } from 'react-redux'
import Image from 'next/image'
import { setCurrentTab, changeExtremeService } from 'src/store/apps/Common'
import { generateMockData } from 'src/utils'
import { buildTimeParams, toMillis } from 'src/utils/dateRangeParams'
import ExtremeUpgradeModal from 'src/@core/components/modal/extreme-upgrade'
import { useExtremeFeatureAccessGate } from 'src/hooks/useExtremeFeatureAccessGate'
import { getUserAccountOrder } from 'src/@api/login'

import { DatePicker } from 'antd'

const { RangePicker } = DatePicker

const CustomRangePicker = styled(RangePicker)`
  .ant-picker-input {// 包裹显示两个时间input的div样式
    width:auto;
  }
  .ant-picker-input > input {// 显示两个时间的input样式
    font-family: Poppins !important;
    font-weight: 400 !important;
    line-height: 24px !important;
    font-size: 16px !important;
    text-align: center;
    text-overflow: clip !important;  /* 禁止使用省略号 */
    overflow: visible !important;    /* 允许文本溢出 */
  }
  .ant-picker-input input[date-range="start"] {
  width: var(--firstWidth) !important;
  }
  .ant-picker-input input[date-range="end"] {
    width: var(--lastWidth) !important;
  }
  .ant-picker-input > input::placeholder {// 显示两个时间的placeholder样式（占位符
    color:#ADADAD;
  }
  .ant-picker-suffix {// 框内icon样式
    order:-1;
    opacity:1 !important;
    margin-right:11px;
  }
  `

const ScrollDiv = styled('div')({
  '@media (max-width: 990px)': {
    '-msOverflowStyle': 'none',  /* 适用于 IE 和 Edge */
    scrollbarWidth: 'none',  /* 适用于 Firefox */
    '&::-webkit-scrollbar': {
      display: 'none', /* 适用于 WebKit 浏览器（如 Chrome、Safari 和新版 Edge） */
    }
  }
})

dayjs.extend(duration)

const Calls = () => {
  const store = useSelector(state => state.Common)
  const { t, locale } = useTranslation('common')

  let Advanced = window.localStorage.getItem('Advanced')
  Advanced = Advanced == null || Advanced == 0 ? true : false

  // ** State
  const [initCalls, setInitCalls] = useState([])
  const [allCalls, setAllCalls] = useState([])
  const [calls, setCalls] = useState([])
  const [active, setActive] = useState('CALL_HISTORY')
  const [currentState, setCurrentState] = useState('all')
  const [antdSelectedDates, setAntdSelectedDates] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [reloadKey, setReloadKey] = useState(0) // 日期变化后强制重拉接口
  const domRef = useRef(null)
  const [maxNum, setMaxNum] = useState(false)
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据

  const [advanced, setAdvanced] = useState(true) // 是否购买高级服务
  const [fetchLoading, setFetchLoading] = useState(true) // 数据获取中
  const basicNotOver = [null, ''].includes(store.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
  const advancedNotOver = [null, ''].includes(store.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
  // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
  const { gatePending, showUpgradeModal } = useExtremeFeatureAccessGate(advanced)
  const [justVerified, setJustVerified] = useState(false) // 是否为刚完成验证

  // 查询数据
  const setCallData = async (page, pageSize) => {
    const username = JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

    // 获取最近的10笔订单
    let res = await getUserAccountOrder({ page: 1, pageSize: 10 })

    // 查找有限期最长的订单
    const lastOrder = res.data.sort((a, b) => dayjs(b.expire_time).valueOf() - dayjs(a.expire_time).valueOf())[0]

    // 计算是否为增值服务上线前付费用户

    // 增值服务上线前付费用户状态更新

    let response = await getAllDashboard({
      username,
      params: {
        category: active,
        offset: (page - 1) * pageSize,
        limit: pageSize,
        // 日期筛选走接口：带 startTime/endTime 时服务端按时间过滤
        ...buildTimeParams(antdSelectedDates),
        deviceUdid:
          JSON.parse(localStorage.getItem('currentDevice')) != null
            ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
            : ''
      }
    })
    setIsLoading(false)
    const advanced = username == null || !('advanced' in response) || ['true', true].includes(response?.advanced) // 高级服务开通状态
    setAdvanced(advanced) // 设置高级服务状态
    dispatch(changeExtremeService(advanced)) // 更新高级服务状态

    if (response.data.contents == null) {
      setMaxNum(true)
      setFetchLoading(false)

      return
    }

    let result = response.data.contents.map(item => {
      return {
        ...item,
        time:
          active == 'VOICEMAIL'
            ? dayjs(Number(`${item.date}000`)).format('YYYY-MM-DD HH:mm')
            : dayjs(Number(`${item.date}`)).format('YYYY-MM-DD HH:mm'),
        url: `https://cos.spyx.com/${item.url}.mp3`,
        type: active,
        playing: false,
        sender: active == 'VOICEMAIL' ? item.sender : item.displayName
      }
    })

    if (advanced) { // 已开通高级服务
      setAllCalls(old => [...old, ...result])
      setInitCalls(result)
    } else {
      const mockData = generateMockData(result) // 生成模拟数据
      setAllCalls([...mockData])
      setInitCalls([...mockData])
    }

    setFetchLoading(false)
  }

  // 页数变化，获取新数据
  useEffect(() => {
    if (!maxNum && advanced) setCallData(currentPage, 50)
  }, [currentPage, active, reloadKey])

  // 升级成功后：预缓冲已在 notify 完成，这里重拉详情读 advanced
  useExtremeUpgradeRefresh(
    useCallback(() => {
      setAdvanced(true)
      setAllCalls([])
      setInitCalls([])
      setCalls([])
      setCurrentPage(1)
      setMaxNum(false)
      setFetchLoading(true)
      setCallData(1, 50)
    }, [])
  )

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 监听进度条滚动
  useEffect(() => {
    const handleScroll = () => {
      if (domRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = domRef.current
        const progress = (scrollTop / (scrollHeight - clientHeight)) * 100
        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = domRef.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])

  useEffect(() => {
    if (scroll >= 100 && advanced) {
      setCurrentPage(old => old + 1)
    }
  }, [scroll])

  // 获取当前状态的数据
  const getStateData = (datas = antdSelectedDates) => {
    const _list = [...allCalls]
    let list = _list.filter(item => {
      if (currentState === 'all') {
        return item
      } else if (currentState === 'outgoing') {
        return item.originated === 1
      } else if (currentState === 'missed') {
        return item.originated === 0 && item.duration === 0
      } else if (currentState === 'incoming') {
        return item.originated === 0 && item.duration !== 0
      } else {
        return item
      }
    })

    if (datas && datas.length === 2) {
      const { startTime, endTime } = buildTimeParams(datas)

      const newDateList = list.filter(item => {
        // item.date 在不同分类下可能是秒或毫秒，统一成毫秒再比较
        const itemTime = toMillis(item.created ?? item.date)

        return itemTime >= startTime && itemTime <= endTime
      })

      list = newDateList
    }

    setCalls(() => [...list])
  }

  // 查看不同状态的通话记录
  useEffect(() => {
    getStateData()
  }, [allCalls, currentState])

  const dispatch = useDispatch()

  useEffect(() => {
    const title = t('Call')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, locale])

  // 获取今天的日期
  const today = dayjs().format('YYYY-MM-DD')

  // 获取七天前的日期
  const sevenDaysAgo = dayjs().subtract(7, 'day').format('YYYY-MM-DD')

  //选择日期范围
  const handleDateChange = dates => {
    const picked = dates && dates.length === 2 ? dates : []

    setAntdSelectedDates(picked)

    if (!advanced) {
      // 未开通高级：列表是本地模拟数据，直接本地筛
      getStateData(picked)

      return
    }

    // 重置分页后由 useEffect 带 startTime/endTime 重新请求接口
    setAllCalls([])
    setInitCalls([])
    setCalls([])
    setMaxNum(false)
    setCurrentPage(1)
    setFetchLoading(true)
    setReloadKey(old => old + 1)
  }

  // 获取最宽日期选择器占位符宽度
  useEffect(() => {

    // 开始时间&结束时间
    let firstDate = '0000-00-00'
    let lastDate = '0000-00-00'

    // 开始时间宽度&结束时间宽度
    let firstWidth = 0
    let lastWidth = 0

    const span = document.createElement('span')
    span.style.setProperty('font-family', 'Poppins', 'important')
    span.style.setProperty('font-size', '16px', 'important')
    span.style.setProperty('font-weight', '400', 'important')
    span.style.setProperty('line-height', '24px', 'important')
    span.style.visibility = 'hidden'
    span.innerText = firstDate

    // 获取第一个占位符宽度
    document.body.appendChild(span)
    firstWidth = span.offsetWidth
    document.body.removeChild(span)

    // 获取第二个占位符宽度
    span.innerText = lastDate
    document.body.appendChild(span)
    lastWidth = span.offsetWidth
    document.body.removeChild(span)

    // 插入至html标签样式中用于调用
    document.documentElement.style.setProperty('--firstWidth', `${firstWidth}px`)
    document.documentElement.style.setProperty('--lastWidth', `${lastWidth}px`)
  }, [])

  return (
    <>
      <Head>
        <meta name="format-detection" content="telephone=no" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      </Head>
      <div className='w-[144px] Blds:w-[528px] h-[33px] Blds:h-[42px] flex bg-[#EAEAEA] Blds:bg-inherit rounded-[8px] mb-[15px] mx-auto'>
        <div className='flex-1 Blds:flex-auto flex justify-center items-center'>
          <div
            className={`${currentState === 'all'
              ? 'bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none'
              : ''
              } w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer`}
            onClick={() => setCurrentState('all')}
          >
            <Image src='/images/calls/all-call.svg' width={24} height={24} alt='all call' />
            <span className='text-[14px] text-[#000] ml-[8px] Bld:hidden'>{t('All Calls')}</span>
          </div>
        </div>
        <div className='flex-1 Blds:flex-auto flex justify-center items-center'>
          <div
            className={`${currentState === 'missed'
              ? 'bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none'
              : ''
              } w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer`}
            onClick={() => setCurrentState('missed')}
          >
            <Image src='/images/calls/missed.svg' width={24} height={24} alt='missed' />
            <span className='text-[14px] text-[#000] ml-[8px] Bld:hidden'>{t('Missed Calls')}</span>
          </div>
        </div>
        <div className='flex-1 Blds:flex-auto flex justify-center items-center'>
          <div
            className={`${currentState === 'outgoing'
              ? 'bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none'
              : ''
              } w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer`}
            onClick={() => setCurrentState('outgoing')}
          >
            <Image src='/images/calls/outgoing.svg' width={24} height={24} alt='outgoing' />
            <span className='text-[14px] text-[#000] ml-[8px] Bld:hidden'>{t('Outgoing Calls')}</span>
          </div>
        </div>
        <div className='flex-1 Blds:flex-auto flex justify-center items-center'>
          <div
            className={`${currentState === 'incoming'
              ? 'bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none'
              : ''
              } w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer`}
            onClick={() => setCurrentState('incoming')}
          >
            <Image src='/images/calls/incoming.svg' width={24} height={24} alt='incoming' />
            <span className='text-[14px] text-[#000] ml-[8px] Bld:hidden'>{t('Incoming Calls')}</span>
          </div>
        </div>
      </div>

      <div className='relative'>
        {
          !fetchLoading && !gatePending &&
          <>
            {
              (!basicNotOver && !advancedNotOver && !justVerified) ?
                <>
                  {/* 高级服务开通提示 */}
                  {showUpgradeModal && <ExtremeUpgradeModal open />}
                </>
                :
                <>
                  {/* 增值服务 iCloud验证流程 */}
                </>
            }

          </>
        }

        <ScrollDiv ref={domRef} className={`bg-[#FFF] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] Mlg:h-[calc(var(--vh2)*100-139px)] lg:Bxl:h-[calc(var(--vh2)*100-148px)] Bxls:Headers5:h-[calc(var(--vh2)*100-206px)] Header5:big:h-[calc(var(--vh2)*100-271px)] bigs:h-[calc(var(--vh2)*100-331px)] px-[16px] smj:px-0 pb-[20px] flex flex-col ${advanced ? 'overflow-auto' : 'overflow-hidden'} relative z-10`}>
          <table className={`border-separate border-spacing-x-[15px] border-spacing-y-[10px] w-full smj:hidden ${!advanced && 'blur-[16px] select-none'}`}>
            <tr className='sticky top-0 bg-[#FFF]'>
              <th className='text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]'>
                {t('NAME OR NUMBER')}
              </th>
              <th className='text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]'>{t('STATE')}</th>
              <th className='text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]'>{t('DURATION')}</th>
              <th className='text-nowrap pt-[10px] text-start text-[14px] text-[#000] font-[600]'>{t('DATE')}</th>
            </tr>
            {calls.map((row, i) => (
              <tr key={i}>
                <td className='text-[14px] text-[#000] text-nowrap'>{row.displayName}</td>
                <td className='text-[14px] text-[#000] text-nowrap flex items-center pr-[30px]'>
                  <Image
                    className='mr-[5px]'
                    src={
                      row.originated === 0
                        ? row.duration === 0
                          ? '/images/calls/missed.svg'
                          : '/images/calls/incoming.svg'
                        : '/images/calls/outgoing.svg'
                    }
                    width={24}
                    height={24}
                    alt={row.originated === 0 ? (row.duration === 0 ? 'missed' : 'incoming') : 'outgoing'}
                  />
                  {row.originated === 0 ? (row.duration === 0 ? t('Missed') : t('Incoming')) : t('Outgoing')}
                </td>
                <td className='text-[14px] text-[#000] text-nowrap'>
                  {dayjs.duration(row.duration, 'seconds').format('mm:ss')}
                </td>
                <td className='text-[14px] text-[#000] text-nowrap'>{row.time}</td>
              </tr>
            ))}
          </table>

          {/* 新ui */}
          <div className={`smjs:hidden h-auto ${!advanced && 'blur-[16px] select-none'}`}>
            <div className='w-full p-[15px_15px_12px] sticky top-0 bg-white border-[#e6e6e6] border-b-[0.5px]'>
              <CustomRangePicker
                format="YYYY-MM-DD" // 左右两边显示的日期格式
                placeholder={[sevenDaysAgo, today]} // 默认显示占位符
                separator={<span className={`text-[#ADADAD]`}>~</span>} // 两个日期的间隔符
                suffixIcon={<Image src="/images/calls/calendar.svg" alt='calendar' width={18} height={18} />} // 替换默认icon
                className='w-full h-[40px] bg-[#F8F8F8]'
                inputReadOnly={true} // 禁用手机弹出输入法 true为不允许弹出
                onChange={handleDateChange}
                getPopupContainer={() => document.getElementById('customRangePicker')}
              />

              <div id='customRangePicker'></div>
            </div>

            {calls.map((row, index) => (
              <div key={index} className='h-[64px] flex w-full'>
                <div className='w-[20px] mt-3 mr-2 ml-[15px]'>
                  {row.originated === 1 && <Image src="/images/calls/outgoing2.svg" alt='outgoing' width={18} height={18} />}
                </div>
                <div className='border-[#e6e6e6] border-b-[0.5px] w-full flex flex-col justify-center h-[64px] font-[Poppins]'>
                  <p className={`text-[16px] font-[500] leading-[24px] ${row.originated === 0 && row.duration === 0 ? ' text-[#FE1616]' : ' text-[#000000]'}`}>{row.displayName || row.address}</p>
                  <div className='flex justify-between'>
                    <p className='text-[14px] font-[400] leading-[21px] text-[#8A8A8E]'>{dayjs.duration(row.duration, 'seconds').format('HH:mm:ss')}</p>
                    <p className='text-[14px] font-[400] text-[#8A8A8E] leading-[21px] mr-[15px]'>{dayjs(row.time).format('YYYY/MM/DD HH:mm')}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {advanced && allCalls.length == 0 && !isLoading &&
            <div className='text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none'>
              {t('It appears theres no data to show here yet')}<br />
              {t('If data exists it may take up to 1 hour to download and appear')}<br />
              {t('We suggest checking back in a little while')}
            </div>}
        </ScrollDiv>
      </div>
    </>
  )
}

export default Calls